"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListSelection = exports.useListSelectionContext = exports.ListSelectionProvider = void 0;
const react_1 = require("react");
const createPropsContextProvider_1 = require("../../utils/createPropsContextProvider");
const createUseDefinedContext_1 = require("../../utils/hooks/createUseDefinedContext");
const context = (0, react_1.createContext)(undefined);
exports.ListSelectionProvider = (0, createPropsContextProvider_1.createPropsContextProvider)(context);
exports.useListSelectionContext = (0, createUseDefinedContext_1.createUseDefinedContext)(context, 'useListSelectionContext requires ListSelectionContext to read list item properties');
const useListSelection = (id) => {
    const { onClick, selectedId, focusedId } = (0, exports.useListSelectionContext)();
    const isSelected = selectedId === id;
    const isFocused = focusedId === id;
    const onClickInjected = (0, react_1.useCallback)(() => onClick(id), [id, onClick]);
    return { isSelected, isFocused, onClick: onClickInjected };
};
exports.useListSelection = useListSelection;
//# sourceMappingURL=ListSelectionProvider.js.map